import { UseFormReturn } from "react-hook-form";
import ApplicantLiabilitiesData from "@/model/interface/ApplicantLiabilities";
import React from "react";
import { Pencil } from "lucide-react";

const inputClass = (hasError: boolean) =>
  `w-full h-11 rounded-lg border bg-white px-4 pr-10 text-sm outline-none transition-colors focus:border-[#0FD131] focus:ring-2 focus:ring-[#9BFBE0] ${hasError ? "border-red-400" : "border-gray-300"}`;

const ApplicantLiabilities = ({ form }: { form: UseFormReturn<ApplicantLiabilitiesData> }) => {
  const { register, formState } = form;

  return (
    <div className="space-y-5">
      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Current mortgage payment (monthly)</h6>
        <input
          type="number"
          {...register("currentMortgagePayment", { valueAsNumber: true })}
          className={inputClass(!!formState.errors.currentMortgagePayment)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.currentMortgagePayment && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.currentMortgagePayment.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Other mortgages</h6>
        <input
          type="text"
          {...register("otherMortgages")}
          className={inputClass(!!formState.errors.otherMortgages)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.otherMortgages && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.otherMortgages.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Car loans</h6>
        <input
          type="text"
          {...register("carLoans")}
          className={inputClass(!!formState.errors.carLoans)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.carLoans && <p className="mt-1 text-sm text-red-500">{formState.errors.carLoans.message}</p>}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Other personal loans</h6>
        <input
          type="text"
          {...register("otherPersonalLoans")}
          className={inputClass(!!formState.errors.otherPersonalLoans)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.otherPersonalLoans && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.otherPersonalLoans.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Credit cards</h6>
        <input
          type="text"
          {...register("creditCards")}
          className={inputClass(!!formState.errors.creditCards)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.creditCards && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.creditCards.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Store cards</h6>
        <input
          type="text"
          {...register("storeCards")}
          className={inputClass(!!formState.errors.storeCards)}
          placeholder="0"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.storeCards && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.storeCards.message}</p>
        )}
      </div>

      <div className="relative">
        <h6 className="text-sm text-gray-500 mb-1">Store cards lenders</h6>
        <input
          type="text"
          {...register("storeCardsLenders")}
          className={inputClass(!!formState.errors.storeCardsLenders)}
          placeholder="Lender names"
        />
        <Pencil className="absolute right-3 top-9 size-3.5 text-gray-400 pointer-events-none" />
        {formState.errors.storeCardsLenders && (
          <p className="mt-1 text-sm text-red-500">{formState.errors.storeCardsLenders.message}</p>
        )}
      </div>

      <div className="flex items-center gap-3">
        <input
          type="checkbox"
          {...register("usedPayDayLender")}
          className="size-5 rounded border-gray-300 text-[#0FD131] focus:ring-[#9BFBE0]"
          id="usedPayDayLender"
        />
        <label htmlFor="usedPayDayLender" className="text-sm text-gray-700">
          Have you ever used a payday lender?
        </label>
      </div>
    </div>
  );
};

export default ApplicantLiabilities;
